<template>
    <div class="d-flex flex-column" :id="id">
        <v-overlay :value="isPageLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row ref="headerFilters">
            <data-table-filters v-if="width>600"
                show-replacement-products-button
                :name="name"
                :subtitleName="subtitleName"
                :has-active-filters="hasActiveFilters"
                :are-advanced-filters-active="areAdvancedFiltersActive"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :advanced_filters="advanced_filters"
                :filters="filters"
                :schema="tSchema(schema)"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters()"
                @apply-advanced-filters="applyAdvancedFilters"
            >
            </data-table-filters>
            <div v-else class="col wrap-title-filters">
             <filters-dialog
                show-replacement-products-button
                :name="name"
                :subtitleName="subtitleName"
                :has-active-filters="hasActiveFilters"
                :are-advanced-filters-active="areAdvancedFiltersActive"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :advanced_filters="advanced_filters"
                :filters="filters"
                :schema="tSchema(schema)"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters()"
                @apply-advanced-filters="applyAdvancedFilters"
              >

             </filters-dialog>
             <v-row no-gutters class="mt-5 mb-2" style="min-height: 26px" v-if="hasFiltersWithArrayType">
                    <v-col>
                        <div v-if="!hasExpandedActiveFilters && filtersWithArrayType.length<=3" ref="collapsedFilter">
                            <span class="dark-blue-color table-filters-text pt-0">{{ $t('orders.base.activeFilters') }}</span>

                            <product-active-filters v-for="(filterType, index) in filtersWithArrayType" :key="index" :items="filterType" :schema="tSchema(schema)" @remove-filter="removeFilter(filterType)"> </product-active-filters>
                        </div>

                        <div v-else>
                            <v-expansion-panels accordion tile flat v-model="activeFiltersActivePanelIndex">
                                <v-expansion-panel>
                                    <v-expansion-panel-header v-if="activeFiltersActivePanelIndex !== 0" class="elevation-0 table-filters-text pt-0 active-filters-listing" expand-icon="mdi-pan-down"> {{ $t('orders.base.showActiveFilters') }} </v-expansion-panel-header>

                                    <v-expansion-panel-header v-else class="elevation-0 table-filters-text pt-0 active-filters-listing" expand-icon="mdi-pan-down"> {{ $t('orders.base.hideActiveFilters') }} </v-expansion-panel-header>

                                    <v-expansion-panel-content>
                                        <v-card class="btn-bg-color-gray filters-list-card">
                                            <v-card-title ref="expandedFilter" class="ma-2 mt-0">
                                                <div class="inner-filters-list-card">
                                                    <product-active-filters v-for="(filterType, index) in filtersWithArrayType" :key="index" :items="filterType" :schema="tSchema(schema)" @remove-filter="removeFilter(filterType)"> </product-active-filters>
                                                </div>
                                            </v-card-title>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-row>

        <v-row v-resize="onResize">
            <v-col cols="12">
                <pure-datatable :endpoint="endpoint" @data-changed="onDataChanges" :queryParams="queryParams" :ready="ready" :customSearch="customSearch" ref="datatable" v-slot:default="{ vOn, vBind, isLoading }">
                    <div>
                        <portal to="v-form-base">
                            <v-form-base :model="filters" :schema="tSchema(schema)" @input="onFiltersChanged"> </v-form-base>
                        </portal>

                        <v-data-table id="base_order"
                            class="elevation-1 d-flex flex-column justify-space-between nowrap-headers"
                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                            fixed-header
                            multi-sort
                            :items="products"
                            :headers="tHeaders(headers)"
                            :header-props="headerProps"
                            :hide-default-headers="isMobile"
                            :class="{mobile: isMobile}"
                            @update:options="refresh"
                            v-on="vOn"
                            v-bind="vBind"
                            hide-default-footer
                            :no-data-text="$t('table.noData')"
                            :no-results-text="$t('table.noResults')"
                            item-key="uniqueId"
                            :loading="isMobile?isLoading:false"
                            :loading-text="$t('table.loading')"
                            :item-class="getLineColor"
                            :footer-props="{
                                showFirstLastPage: false,
                                itemsPerPageOptions: itemsPerPageOptions,
                                itemsPerPageText: $t('table.itemsPerPage'),
                            }"
                        >
                            <template v-if="!isMobile" #[`header.has_campaign`]>
                                <v-icon style="left: 10%">mdi-star-outline</v-icon>
                            </template>

                            <template v-if="!isMobile" #[`item.designation`]="scope">
                                <div class="d-flex justify-start align-center pl-6" data-cy="designations">
                                   <!-- <product-image :productCode="scope.item.invoice_code" mdi-video-outline :imageSrc="scope.item.image" :is-new="!!scope.item.new" width="35" height="35" max-width="35" max-height="35" style="cursor: pointer; position: relative" @click="openProductDetails(scope.item)"></product-image>
                                    v-if="scope.item.has_video"v-if="scope.item.new"-->
                                    <div class="datatable-new" v-if="scope.item.new">
                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-on="on" v-bind="attrs">mdi-new-box</v-icon>
                                            </template>
                                            <span>{{ $t('orders.base.newProduct') }}</span>
                                        </v-tooltip>
                                   </div>
                                   <div class="datatable-video" v-if="scope.item.has_video">
                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-on="on" v-bind="attrs"> mdi-youtube</v-icon>
                                            </template>
                                            <span>{{ $t('orders.base.featuredVideo') }}</span>
                                        </v-tooltip>
                                   </div>
                                    <div class="datatable-image">
                                        <div class="image-product-list" :style="'background-image: url('+scope.item.thumbnail+');'" @click="openProductDetails(scope.item)"></div>
                                    </div>
                                    <div class="pl-2 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(scope.item)">
                                        {{ scope.item.designation }}
                                    </div>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.has_current_stock`]="scope">
                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" data-cy="stocks">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-if="!scope.item.orderable" style="left: -15%" :color="isAvailable(scope.item) ? 'green' : 'red'" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                        <v-icon v-else style="left: -15%" color="blue" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                    </template>
                                    <span v-if="!scope.item.orderable">{{ isAvailable(scope.item) ? $t('orders.base.stockAvailable') : $t('orders.base.confirmStock') }}</span>
                                    <span v-else>{{ $t('orders.base.orderableConfirmStock') }}</span>
                                </v-tooltip>
                            </template>

                            <template v-if="!isMobile" #[`item.extraIcons`]="scope">
                                <product-additional-info :product="scope.item"> </product-additional-info>
                            </template>

                            <template v-if="!isMobile" #[`item.laboratory__name`]="scope">
                                {{ scope.item.laboratory.name }}
                            </template>

                            <template v-if="!isMobile" #[`item.pricetable_price`]="scope">
                                <div class="d-flex">
                                    <template v-if="scope.item.discount">
                                        <v-list-item-content class="py-0">
                                            <div class="flex-column" style="line-height: 18px">
                                                <p class="red--text text-decoration-strikethrough mb-0" style="font-size: 0.6rem">{{ formatPrice(scope.item.price) }}</p>
                                                <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.6rem">{{ formatPrice(scope.item.price - scope.item.price * (scope.item.discount / 100)) }}</v-list-item-subtitle>
                                            </div>
                                        </v-list-item-content>
                                    </template>

                                    <template v-else-if="scope.item.value">
                                        <v-list-item-content class="py-0">
                                            <div class="flex-column" style="line-height: 18px">
                                                <p class="red--text text-decoration-strikethrough mb-0" style="font-size: 0.6rem">{{ formatPrice(scope.item.price) }}</p>
                                                <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.6rem">{{ formatPrice(scope.item.value) }}</v-list-item-subtitle>
                                            </div>
                                        </v-list-item-content>
                                    </template>

                                    <template v-else>
                                        {{ formatPrice(scope.item.price) }}
                                    </template>

                                    <product-discounts-icon :inTable="true" v-if="userStore.hasPermissionTo('View discounts icon')" :product="scope.item"></product-discounts-icon>
                                </div>
                            </template>
                            <template v-if="!isMobile" #[`item.has_campaign`]="scope">
                                <template v-if="userStore.hasPermissionTo('View campaigns') && !branchNoCampaigns &&!normalOrderStore.checkIfPubArticle(scope.item)">
                                    <campaign-tooltip v-if="productHasActiveCampaign(scope.item.id)" isOutlined :text="$t('orders.base.campaignApplied')" @click="onClickProductCampaign(scope.item)"></campaign-tooltip>
                                    <campaign-tooltip v-else-if="!productHasActiveCampaign(scope.item.id) && scope.item.has_campaign" :text="$t('orders.base.withCampaign')" @click="onClickProductCampaign(scope.item)"></campaign-tooltip>
                                </template>
                            </template>

                            <template v-if="!isMobile" #[`item.ordered_amount`]="scope">
                                <div data-cy="ordered-amount">{{ scope.item.ordered_amount }}</div>
                            </template>

                            <template v-if="!isMobile" #[`item.quantity`]="scope">
                                <quantity-counter
                                    :value="productHasActiveCampaign(scope.item.id) ? normalOrderStore.getAggregatedQuantities(scope.item.id) : normalOrderStore.getCartProductQuantity(scope.item)"
                                    class="justify-space-between mx-auto"
                                    @input="tryUpdateQuantity(normalOrderStore.isInCart(scope.item) ? normalOrderStore.getProduct(scope.item.id) : scope.item, $event)"
                                    @increment="tryIncrement(normalOrderStore.isInCart(scope.item) ? normalOrderStore.getProduct(scope.item.id) : scope.item, 1)"
                                    @decrement="tryIncrement(normalOrderStore.isInCart(scope.item) ? normalOrderStore.getProduct(scope.item.id) : scope.item, -1)"
                                    :disabled="productHasActiveCampaign(scope.item.id)|| branchStore.cannotPurchase "
                                    :hide-counter="productHasActiveCampaign(scope.item.id) || branchStore.cannotPurchase "
                                ></quantity-counter>
                            </template>

                            <template v-if="!isMobile" #[`item.bonus`]="scope">
                                <div class="d-flex align-center justify-center" v-if="!normalOrderStore.checkIfPubArticle(scope.item)">
                                    <quantity-counter
                                        :readonly="!canChangeBonusQuantity"
                                        :hide-counter="!canChangeBonusQuantity || branchStore.cannotPurchase"
                                        :hide-input="!canChangeBonusQuantity || branchStore.cannotPurchase"
                                        :value="offerBonusQuantity(scope.item)"
                                        @input="tryChangeProductBonus(scope.item, $event, true)"
                                        @increment="tryChangeProductBonus(scope.item, 1)"
                                        @decrement="tryChangeProductBonus(scope.item, -1)"
                                    ></quantity-counter>
                                </div>
                            </template>
                            <template v-if="!isMobile" #[`item.vat__tax`]="scope">{{ scope.item.vat.tax }}%</template>
                            <template v-if="!isMobile" #[`item.actions`]="scope">
                                <div class="d-flex justify-end align-center">
                                    <product-comment :style="!productHasActiveCampaign(scope.item.id) && normalOrderStore.isInCart(scope.item) ? 'visibility: visible' : 'visibility: hidden'" :product="scope.item"></product-comment>

                                    <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="openProductDetails(scope.item)" data-cy="product-details"> mdi-dots-horizontal-circle-outline </v-icon>
                                </div>
                            </template>
                            <template v-if="isMobile" v-slot:item="{ item, index }">
                              <tr>
                                <v-card
                                    elevation="2"
                                    >
                                    <v-row>
                                        <v-col class="d-flex flex-column col pt-0 pb-0 pl-0 pr-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">
                                                <v-col  class="col col-3 pt-0 pb-0">
                                                    <div class="datatable-image"><div class="image-product-list" :style="'background-image: url('+item.thumbnail+');'" @click="openProductDetails(item)"></div></div>
                                                </v-col>
                                                <v-col  class="col col-9 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-12 pt-0 pb-0">
                                                            <div class="pl-0 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(item)">
                                                                {{ item.designation }}
                                                            </div>
                                                        </v-col>
                                                        <v-col  class="col col-12 pt-0 pb-0">
                                                            <div class="pl-0 datatable-lable-text laboratory">
                                                                {{ item.laboratory.name}}
                                                            </div>
                                                        </v-col>
                                                        <v-col class="col col-12 pt-0 pb-0 stock">
                                                            <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" data-cy="stocks">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon v-if="!item.orderable" :color="isAvailable(item) ? 'green' : 'red'" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                                                    <v-icon v-else color="blue" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                                                </template>
                                                                <span v-if="!item.orderable">{{ isAvailable(item) ? $t('orders.base.stockAvailable') : $t('orders.base.confirmStock') }}</span>
                                                                <span v-else>{{ $t('orders.base.orderableConfirmStock') }}</span>
                                                            </v-tooltip>
                                                            <product-additional-info :product="item"> </product-additional-info>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col  class="col col-12 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-6 pt-0 pb-0">
                                                        </v-col>
                                                        <v-col class="col col-6 pt-0 pb-0">
                                                            <div class="d-flex justify-end align-center" >
                                                                <template v-if="userStore.hasPermissionTo('View campaigns') && !branchNoCampaigns && !normalOrderStore.checkIfPubArticle(item)">
                                                                <campaign-tooltip v-if="productHasActiveCampaign(item.id) && !normalOrderStore.checkIfPubArticle(item)" isOutlined :text="$t('orders.base.campaignApplied')" @click="onClickProductCampaign(item)"></campaign-tooltip>
                                                                <campaign-tooltip v-else-if="!productHasActiveCampaign(item.id) && item.has_campaign && !normalOrderStore.checkIfPubArticle(item)" :text="$t('orders.base.withCampaign')" @click="onClickProductCampaign(item)"></campaign-tooltip>
                                                            </template>
                                                            <div class="datatable-new" v-if="item.new">
                                                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-icon v-on="on" v-bind="attrs">mdi-new-box</v-icon>
                                                                        </template>
                                                                        <span>{{ $t('orders.base.newProduct') }}</span>
                                                                    </v-tooltip>
                                                            </div>
                                                            <div class="datatable-video" v-if="item.has_video">
                                                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-icon v-on="on" v-bind="attrs"> mdi-youtube</v-icon>
                                                                        </template>
                                                                        <span>{{ $t('orders.base.featuredVideo') }}</span>
                                                                    </v-tooltip>
                                                            </div>
                                                                <product-comment :style="!productHasActiveCampaign(item.id) && normalOrderStore.isInCart(item) ? 'visibility: visible' : 'visibility: hidden'" :product="item"></product-comment>

                                                                <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="openProductDetails(item)" data-cy="product-details"> mdi-dots-horizontal-circle-outline </v-icon>
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                 </v-col>
                                                 <v-col  class="col col-12 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-6 pt-0 pb-0 pl-0">
                                                            <div class="col pt-0 pb-0 label">{{ $t('orders.base.quantity') }}</div>
                                                            <quantity-counter
                                                                :value="productHasActiveCampaign(item.id) ? normalOrderStore.getAggregatedQuantities(item.id) : normalOrderStore.getCartProductQuantity(item)"
                                                                class="justify-space-between mx-auto"
                                                                @input="tryUpdateQuantity(normalOrderStore.isInCart(item) ? normalOrderStore.getProduct(item.id) : item, $event)"
                                                                @increment="tryIncrement(normalOrderStore.isInCart(item) ? normalOrderStore.getProduct(item.id) : item, 1)"
                                                                @decrement="tryIncrement(normalOrderStore.isInCart(item) ? normalOrderStore.getProduct(item.id) : item, -1)"
                                                                :disabled="productHasActiveCampaign(item.id) || branchStore.cannotPurchase"
                                                                :hide-counter="productHasActiveCampaign(item.id) || branchStore.cannotPurchase "
                                                            ></quantity-counter>
                                                        </v-col>
                                                        <v-col class="col col-6 pt-0 pb-0 pl-0">
                                                            <div class="col pt-0 pb-2 empty"></div>
                                                            <div class="col pt-0 pb-2  pl-0 pr-0 label lf "><div class="l-sub">{{ $t('orders.base.vat') }}</div><div class="l-sub-value">{{item.vat.tax}} %</div></div>

                                                        </v-col>
                                                    </v-row>
                                                 </v-col>
                                                 <v-col  class="col col-12 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-6 pt-0 pb-0 pl-0">
                                                            <div class="col pt-0 pb-0 label"  v-if="!normalOrderStore.checkIfPubArticle(item)">{{ $t('orders.base.bonus') }}</div>
                                                           <!--<quantity-counter
                                                            :value="productHasActiveCampaign(item.id) ? normalOrderStore.getAggregatedQuantities(item.id) : item.quantity"
                                                            class="justify-space-between mx-auto"
                                                            @input="tryUpdateQuantity(item, $event)"
                                                            @increment="tryIncrement(item, 1)"
                                                            @decrement="tryIncrement(item, -1)"
                                                            :disabled="productHasActiveCampaign(item.id)"
                                                            :hide-counter="productHasActiveCampaign(item.id)"
                                                        ></quantity-counter>-->
                                                        <quantity-counter  v-if="!normalOrderStore.checkIfPubArticle(item)"
                                                            :readonly="!canChangeBonusQuantity"
                                                            :hide-counter="!canChangeBonusQuantity || branchStore.cannotPurchase "
                                                            :hide-input="!canChangeBonusQuantity || branchStore.cannotPurchase "
                                                            :value="offerBonusQuantity(item)"
                                                            @input="tryChangeProductBonus(item, $event, true)"
                                                            @increment="tryChangeProductBonus(item, 1)"
                                                            @decrement="tryChangeProductBonus(item, -1)"
                                                        ></quantity-counter>
                                                        </v-col>
                                                        <v-col class="col col-6 pt-0 pb-0 pl-0">
                                                            <div class="col pt-0 pb-2 empty"></div>
                                                            <div class="col pt-0 pb-2  pl-0 pr-0 label lf "><div class="l-sub">{{ $t('orders.base.price') }}</div><div class="l-sub-value">
                                                                <template v-if="item.discount">
                                                                        <v-list-item-content class="py-0">
                                                                            <div class="flex-column" style="line-height: 18px">
                                                                                <p class="red--text text-decoration-strikethrough mb-0" style="font-size: 0.6rem">{{ formatPrice(item.price) }}</p>
                                                                                <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.6rem">{{ formatPrice(item.price - item.price * (item.discount / 100)) }}</v-list-item-subtitle>
                                                                            </div>
                                                                        </v-list-item-content>
                                                                    </template>

                                                                    <template v-else-if="item.value">
                                                                        <v-list-item-content class="py-0">
                                                                            <div class="flex-column" style="line-height: 18px">
                                                                                <p class="red--text text-decoration-strikethrough mb-0" style="font-size: 0.6rem">{{ formatPrice(item.price) }}</p>
                                                                                <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.6rem">{{ formatPrice(item.value) }}</v-list-item-subtitle>
                                                                            </div>
                                                                        </v-list-item-content>
                                                                    </template>

                                                                    <template v-else>
                                                                        {{ formatPrice(item.price) }}
                                                                        <product-discounts-icon :inTable="true" v-if="userStore.hasPermissionTo('View discounts icon')" :product="item"></product-discounts-icon>
                                                                    </template>
                                                            </div>
                                                           </div>

                                                        </v-col>
                                                    </v-row>
                                                 </v-col>

                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </tr>
                            </template>
                            <template v-slot:footer="scope">
                                <div>
                                    <div class="datatable-footer-border"></div>

                                    <data-table-footer :showExport="canExport()" :scope="scope" @export="exportData" @updateOptions="refresh" @purchase="purchase()" :isLoading="isLoading" style="height: fit-content"> </data-table-footer>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </pure-datatable>
            </v-col>
        </v-row>

        <product-campaign-form
            v-if="isDetailedCampaignDialogOpen"
            :key="selectedProduct.id"
            :isOpen="isDetailedCampaignDialogOpen"
            :product="selectedProduct"
            :campaigns="manipulatedProductCampaigns"
            :account-blocked-message="accountBlockedMessage"
            :currentSearchTerm="currentSearchTerm"
            @input="onCloseDetailedCampaignDialog()"
            @check-applied-campaigns="checkAppliedCampaigns()"
            @create-new-original-campaign="createNewOriginalCampaign($event)"
            @show-campaigns="onClickProductCampaign"
        ></product-campaign-form>

        <app-dialog v-if="isProductDetailsDialogOpen" :isProductDetails="true" :value="isProductDetailsDialogOpen" @input="isProductDetailsDialogOpen = $event" :title="$t('orders.base.productSheet')" width="55vw" :isResponsive="true" :showActions="false">
            <template v-slot:content>
                <product-details :product="selectedProduct" :key="selectedProduct.id" :current-search-term="currentSearchTerm" @change-product="selectedProduct = $event" @show-campaigns="onClickProductCampaign"></product-details>
            </template>
        </app-dialog>

        <purchase-conditions-dialog :value="isProductShippingConditionsDialogOpen" :product="selectedProduct" @cancel="isProductShippingConditionsDialogOpen = false" @success="acceptedShippingConditions" :title="$t('orders.base.information')" width="40vw"> </purchase-conditions-dialog>
        <confirmation-dialog
            :value="isProductInPendingProductsDialogOpen"
            @onSuccess="acceptedPendingProductList()"
            @onCancel="isProductInPendingProductsDialogOpen = false"
            :title="$t('layout.attention')"
            :question="$t('orders.base.alreadyPendingQuestion')"
        ></confirmation-dialog>

        <confirmation-dialog :value="isRemoveCampaignDialogOpen" @onSuccess="acceptedRemoveCampaign()" @onCancel="isRemoveCampaignDialogOpen = false" :title="$t('layout.attention')" :question="$t('orders.base.removeCampaignQuestion')"> </confirmation-dialog>

        <v-dialog
            v-model="isOfferTypeDialogOpen"
            persistent
            max-width="380"
            >
                <v-card class="myprovet-dialog-card select-offer-type" :max-height="200" :height="160" data-cy="app-dialog-card">
                <!--<v-card-title v-if="!isAlertDialog" class="d-flex justify-space-between align-center title-text dark-blue-color mx-1 px-6" data-cy="app-dialog-title">
                    Selecionar a origem do bónus
                    <v-spacer></v-spacer>
                </v-card-title>-->
                <v-card-text class="px-6 pb-2 pt-6">
                    <v-select
                    style="width:300px; font-size: 1rem!important;"
                    :items="bonusTypes"
                    v-model="currentOfferType"
                                        :label="$t('orders.base.selectBonusType')"
                    @change="setBonusTypes"
                    >
                    <template v-slot:item="{ item }">{{ tb(item) }}</template>
                    <template v-slot:selection="{ item }">{{ tb(item) }}</template></v-select>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>

1<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useCategoriesStore } from '@/Stores/categories';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import PureDatatable from '@arentia/atools/PureDatatable';
import VFormBase from 'vuetify-form-base';
import ResizeObserver from 'resize-observer-polyfill';
import FiltersDialog from '../Dialog/FiltersDialog.vue';

export default {
    components: {
        VFormBase,
        PureDatatable,
        FiltersDialog
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],
        advanced_filters: Array,
        accountBlockedMessage: String,
        endpoint: String,
        name: String,
        subtitleName: String,
        id:String
    },

    data: () => ({
        width:null,
        isMobile:false,
        activeFiltersActivePanelIndex: null,
        isPageLoading: false,
        isLoading: false,

        datatableSize: 200,
        resizeObserver: null,

        filters: {},
        queryParams: {},
        ready: false,
        hasExpandedActiveFilters: false,

        selectedProduct: {},

        products: [],
        expandedProducts: [],
        productCampaigns: [],
        originalProductCampaigns: [],
        manipulatedProductCampaigns: [],

        isDetailedCampaignDialogOpen: false,
        isProductDetailsDialogOpen: false,

        // Shipping conditions
        onAcceptedCallback: null,
        isProductShippingConditionsDialogOpen: false,

        isProductInPendingProductsDialogOpen: false,

        isRemoveCampaignDialogOpen: false,
        isOfferTypeDialogOpen: false,
        bonusTypes:['BONUS FORN','BONUS PROP'],
        currentOfferType:null,
        currentBonus:null,
        isAbsoluteAmountValue:false,
        amount:0,
        areAdvancedFiltersActive: false,
        advancedFilters: null,
        itemsPerPageOptions: window.innerWidth<=1024?[20,40,60,100]:[20,40,60],
        customSearch: {
            designation: `{
                "type": "query-builder-group",
                "query": {
                    "logicalOperator": "any",
                    "children": [
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "code",
                                "operator": "contains",
                                "operand": "code",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "ean",
                                "operator": "contains",
                                "operand": "ean",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "invoice_code",
                                "operator": "contains",
                                "operand": "invoice_code",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "designation",
                                "operator": "keywords",
                                "operand": "designation",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "laboratory.name",
                                "operator": "contains",
                                "operand": "laboratory.name",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "species.description",
                                "operator": "contains",
                                "operand": "species.description",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "pharma_composition.description",
                                "operator": "contains",
                                "operand": "pharma_composition.description",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "active_substances.description",
                                "operator": "contains",
                                "operand": "active_substances.description",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "administration_route.description",
                                "operator": "contains",
                                "operand": "administration_route.description",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "range.description",
                                "operator": "contains",
                                "operand": "range.description",
                                "value": "__designation__"
                            }
                        }
                    ]
                }
            }`,
        },
    }),

    watch: {
        'branchStore.branch': {
            handler: function (branch, oldBranch) {
                if (!branch) return;

                this.queryParams.branch_id = branch.id;
                this.itemsPerPageOptions=this.getItemsPerPageOptions()

                // Reload the page if the old branch and the new one have different no_campaigns value.
                // Datatable should show or hide the has_campaign column.
                if (branch && oldBranch && branch.id != oldBranch.id && branch.no_campaigns != oldBranch.no_campaigns) location.reload();

                this.ready = true;
                this.$nextTick(() => this.refresh());
            },
            immediate: true,
        },
        isDetailedCampaignDialogOpen: {
            handler: function (value) {
                if (!value) {
                    useNormalOrderStore().clearAllOldCarts(this.userStore.user.id, this.branchStore.branch.id, ['baseCampaigns'],true);
                }
            },
        }
    },

    created() {
        this.applySearchToFilters();
        this.applyDefaultFilters();

    },

    mounted() {
        this.prepareResponsiveBehaviour();

        window.EventBus.$on('product-quantity-change', () => {
            this.refresh();

            if (this.isDetailedCampaignDialogOpen) {
                this.onClickProductCampaign(this.selectedProduct);
            }
        });

        window.EventBus.$on('updated-product-stocks', ({ data }) => {
            this.products.forEach((product, index) => {
                const productStock = data.find((p) => p.code == product.code);
                if (productStock && product.has_current_stock != productStock.has_current_stock) {
                    this.$set(this.products[index], 'has_current_stock', productStock.has_current_stock);
                    this.$set(this.selectedProduct, 'has_current_stock', productStock.has_current_stock);
                }
            });
        });

        window.EventBus.$on('update:product-search', (e) => {
            //console.log('product-search',e)
            this.setSearchByCamera(e)
        })
        this.width=window.innerWidth
        let portrait = window.matchMedia("(orientation: portrait)");
        portrait.addEventListener("change", (e)=> {
             // Do change
                 this.refreshDeely()
                this.checkHeaders();

        })
        this.checkHeaders();
    },

    beforeDestroy() {
        window.EventBus.$off('update:product-search', null)
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
        window.EventBus.$off('check-if-should-underflow2', this.checkIfShouldUnderflow);
        window.EventBus.$off('updated-product-stocks');
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useCategoriesStore, useNormalOrderStore,useAppStore),

        isExpressOrder() {
            return this.name.includes('Express');
        },

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        hasItems() {
            return this.normalOrderStore.getProductCount > 0 || this.normalOrderStore.getCampaignCount > 0;
        },

        canChangeBonusQuantity() {
            return this.userStore.hasPermissionTo('Change bonus quantity (as propec)') || this.userStore.hasPermissionTo('Change bonus quantity (as supplier)');
        },

        currentSearchTerm() {
            return this.filters.designation;
        },

        branchNoCampaigns() {
            return this.branchStore.hideCampaigns;
        },
        filtersWithArrayType() {
            // Some arrays are not supposed to be listed (like branches for example, as the list could become extremely big for admins, etc).
            const keys = Object.keys(this.filters).filter((f) => f != 'branch__id' && f != 'branches##id' && Array.isArray(this.filters[f]));

            return keys.map((k) => this.filters[k]);
        },

        hasFiltersWithArrayType() {
            return this.filtersWithArrayType.flat().length;
        },
        headerProps(){
            return this.appStore.header_props
        },
        /*isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },*/
    },

    methods: {
        getItemsPerPageOptions(){

            let option= [20,40,50]

            if(this.canChangeBonusQuantity){
                option= [20,40,50,100,200]
            }else{
                if(window.innerWidth>=768&&window.innerWidth<=1366){
                    option= [20,40,50,100]
                }
            }
           return option
        },
        getBase64(data){
           const mimeType = 'image/jpg';
           const imgBase64 = data;

          return `data:${mimeType};base64,${imgBase64}`;
        },
        checkHeaders(){
            let windowWidth = window.innerWidth;
            if (windowWidth <= 600) {
                _.each(this.headers,(o)=>{
                    if(o.value=='has_campaign'){
                        o.text='Campanha'
                    }
                })
            }else{
                _.each(this.headers,(o)=>{
                    if(o.value=='has_campaign'){
                        o.text=''
                    }
                })
            }
        },
        onResize(){
         //console.log('onResize',window.innerWidth)
         if(window.innerWidth<=760){
            this.isMobile= window.innerWidth>600?false:true
         }else{
            this.isMobile=false
         }
        },
        checkIfShouldOverflow() {
            // We need to run on the next tick because the new filter should be added first.
            //console.log('in checkIfShouldOverflow',this.$refs.collapsedFilter);
            this.$nextTick(() => {
                const element = this.$refs.collapsedFilter;
                if (!element) return;

                let sizeAfter = element.clientHeight;
                if (sizeAfter > 30) this.$emit('expand-active-filters', true);
            });
        },

        checkIfShouldUnderflow() {
            const wasExpanded = this.activeFiltersActivePanelIndex === 0;
            const hadOverflow = this.hasExpandedActiveFilters;
            //console.log('in checkIfShouldUnderflow',hadOverflow,this.activeFiltersActivePanelIndex);
            // To calculate the space, we need to show all of the filters.
            this.$emit('expand-active-filters', false);

            // We need to run on the next tick because the filters need to be in the DOM.
            this.$nextTick(() => {
                const element = this.$refs.collapsedFilter;
                if (!element) return;

                let isUnderflowing = element.clientHeight < 45;

                if (isUnderflowing) this.$emit('expand-active-filters', false);
                // If the user had the active filters opened, keep it open.
                if (hadOverflow && wasExpanded && !isUnderflowing) {
                    this.$emit('expand-active-filters', true);
                    this.activeFiltersActivePanelIndex = 0;
                }
            });
        },
        setItemsPorPage(){
            this.itemsPerPageOptions=this.getItemsPerPageOptions()//window.innerWidth>=768&&window.innerWidth<=1366?[20,50,100]:[10,20,50]//[10,20,50]//window.innerWidth<=1024?[20,50,100]:[10,20,50]
        },
        refreshDeely(){
            setTimeout(()=>{
                    this.refresh();
                    this.width=window.innerWidth
                },300)
        },
        canExport() {
            return (
                (this.isExpressOrder && this.userStore.hasPermissionTo('Export express order')) || //
                (!this.isExpressOrder && this.userStore.hasPermissionTo('Export normal order'))
            );
        },

        exportData() {
            if (!this.branchStore.branch || !this.$refs.datatable) return;

            const axiosSettings = {
                url: this.isExpressOrder ? '/api/orders/express/export' : '/api/orders/normal/export',
                params: {
                    branch_id: this.branchStore.branch.id,
                },
            };

            const filename = this.isExpressOrder ? 'export_encomenda_favoritos' : 'export_encomenda_normal';

            this.$refs.datatable.exportData(axiosSettings, filename);
        },

        updateCampaignQuantity(product, isIncrement) {
            let quantity = product.quantity;

            if (product.exceeding_quantity) {
                if (product.totalQuantity > product.min_quantity) {
                    product.totalQuantity == isIncrement //
                        ? product.totalQuantity + product.quantity
                        : product.totalQuantity - product.quantity;
                }

                quantity = product.totalQuantity;
            }

            !isIncrement && quantity <= product.min_quantity //
                ? this.tryRemoveCampaign(product, isIncrement)
                : this.normalOrderStore.changeCampaignQuantityOnExisting(product.campaign_unique_id, product.index, isIncrement, this.currentSearchTerm);
        },

        getCampaignColor(item) {
            if (!item.campaign_id) return;

            return item.campaign_color;
        },
        getLineColor(item){

            if(this.userStore.hasPermissionTo('Change bonus quantity (as propec)')){

                if(_.has(item,'offer_type')){
                    if(item.offer_type==='BONUS PROP')
                        return item.campaign_color? item.campaign_color+' bonus-prop':' bonus-prop';
                    if(item.offer_type==='BONUS FORN')
                        return item.campaign_color? item.campaign_color+' bonus-forn':' bonus-forn';
                 }
            }

            if(item.offer_type==null){
                if(item.quantity>0){
                    return item.campaign_color+' bonus-prop';
                }
            }
            if (!item.campaign_id) return;

            return item.campaign_color;
        },
        prepareResponsiveBehaviour() {
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);

            window.addEventListener('resize', makeResponsive);

            makeResponsive();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 75 - topHeight;
                this.datatableSize = res;
            }
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);
            this.onFiltersChanged();
        },
        onFiltersChanged() {

            let hasAutoSearch = this.userStore.user?.auto_search_disabled
            if(this.isIOS()){
                if(!hasAutoSearch){
                    this.setFiltersChanged()
                }
            }else{
                this.setFiltersChanged()
            }
        },
        setFiltersChanged(){
            this.refresh();
            this.checkIfShouldUnderflow();
            window.EventBus.$emit('check-if-should-overflow');
        },
        setSearchByCamera(searchTerm){
            //this.$set(this.model, 'designation', searchTerm);
            this.$set(this.filters, 'designation', searchTerm);
            this.refresh()
        },
        setSearch(searchTerm) {
            this.$set(this.model, 'designation', searchTerm);
        },
        applySearchToFilters() {
            const urlParams = new URLSearchParams(window.location.search);
            const searchTerm = urlParams.get('q');
            this.setSearch(searchTerm);
        },
        clearSearch() {
            const urlParams = new URLSearchParams(window.location.search);
            const searchTerm = urlParams.get('q');
            if (searchTerm) this.setSearch('');
        },

        setFieldsDisabledStateTo(bool) {
            for (const key in this.schema) {
                this.schema[key].disabled = bool;
            }
        },

        applyAdvancedFilters(advancedFilters) {
            this.clearNormalFilters();
            this.areAdvancedFiltersActive = true;

            const baseQueryBuilder = {
                logicalOperator: 'all',
                children: [
                    {
                        type: 'query-builder-group',
                        query: advancedFilters,
                    },
                ],
            };

            this.advancedFilters = baseQueryBuilder;

            // Disable the basic filters if the advanced filters are active.
            this.setFieldsDisabledStateTo(true);

            this.refresh();
        },

        refresh(options) {
            this.checkIfShouldUnderflow();
            if (!this.branchStore.branch) return;

            const query = this.areAdvancedFiltersActive ? this.advancedFilters : this.filters;

            if (this.$refs.datatable) {
                if (options) {
                    this.$refs.datatable.setLocalOptions(options);
                }else{
                    options=this.$refs.datatable.localOptions
                    //options.itemsPerPage=10//window.innerWidth>=768&&window.innerWidth<=1366?20:10//10//window.innerWidth<=1024?20:10
                    /*if(window.innerWidth<=768){
                        options.itemsPerPage=20
                    }else{
                        options.itemsPerPage=10
                    }*/
                    options.itemsPerPage=20
                    this.$refs.datatable.setLocalOptions(options);
                }
                this.$refs.datatable.onChangeQueryBuilder(query, this.schema);
            }
        },

        purchase() {
            if (this.branchStore.isBlocked) {
                this.showError(this.accountBlockedMessage);
                return;
            }

            if (!this.hasItems) {
                this.showError(this.$t('orders.base.cartEmpty'));
                return;
            }

            const client_number = this.branchStore.branch?.client_number;
            const company_branch = this.branchStore.branch?.company_branch;

            this.$inertia.visit(`/orders/normal/cart/${client_number}/${company_branch}`);
        },

        isAvailable(product) {
            return  product.has_current_stock;
        },

        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        clearNormalFilters() {
            this.clearSearch();
            this.applyDefaultFilters();
            this.hasExpandedActiveFilters = false;

            // Enable the basic filters if the advanced filters are not active.
            this.setFieldsDisabledStateTo(false);

            this.refresh();
        },

        onClearFilters() {
            this.areAdvancedFiltersActive = false;
            this.clearNormalFilters();
        },

        onClickProductCampaign(product) {
            this.isPageLoading = true;

            // Close the dialog if it's currently open with another campaign
            if (this.isProductDetailsDialogOpen) this.isProductDetailsDialogOpen = false;
            if (this.isDetailedCampaignDialogOpen) this.isDetailedCampaignDialogOpen = false;

            const targetData = {
                branch_id: this.branchStore.branch?.id,
                product_code: product.code,
            };

            // Obtain fresh data for the product that was used for the latest campaigns dialog trigger
            axios.post('/api/products/single/', targetData).then(({ data }) => {
                if (!data[0]) {
                    this.isPageLoading = false;
                    this.showError(this.$t('orders.base.productLoadError'));
                    return;
                }
                this.selectedProduct = data[0];
                this.getCampaigns();
            });
        },

        getCampaigns() {
            this.isPageLoading = true;

            axios
                .get('/api/campaigns', {
                    params: {
                        reference: this.selectedProduct.code,
                        branch_id: this.branchStore.branch?.id,
                        campaign_id: this.selectedProduct.campaign_id,
                    },
                })
                .then((response) => {
                    this.isPageLoading = false;
                    let results=response.data
                    _.each(results,(elem)=>{
                        if(elem.description==null){
                            if(elem.offer_quantity>0){
                                let target = String(this.selectedProduct.code);
                                let requirement = _.find(elem.requirements, r => String(r.referenceable) === target);
                                //let requirement = _.find(elem.requirements,{referenceable:''+this.selectedProduct.code})
                                let baseQty = requirement?requirement.min_quantity:elem.requirements[0].min_quantity;
                                let offerQty = elem.offer_quantity
                                if(requirement){
                                    if(!requirement.obs){
                                        elem.description = 'NA COMPRA DE '+baseQty+' UNI, '+offerQty+' DE OFERTA'
                                    }
                                }else{
                                    elem.description = 'NA COMPRA DE '+baseQty+' UNI, '+offerQty+' DE OFERTA'
                                }
                            }
                        }
                    })
                    this.productCampaigns =results;
                    this.originalProductCampaigns = JSON.parse(JSON.stringify(this.productCampaigns));

                    if (this.productCampaigns.length == 0) {
                        this.showError(this.$t('orders.base.campaignsUnavailable'));
                    } else {
                        this.checkAppliedCampaigns();
                        this.isDetailedCampaignDialogOpen = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isPageLoading = false;
                });
        },
        handleStoredMixCampaigns() {
            // Check if there are stored mixs to show
            // We don't want to get the simple campaigns where the originating product id is 999999
            let campaigns = [];
            const all_stored_campaigns = this.normalOrderStore.getCampaignsWithoutSimpleCampaigns;

            if (all_stored_campaigns.length > 0) {
                this.productCampaigns.forEach((campaign) => {
                    const stored_campaigns = all_stored_campaigns.filter((sc) => {
                        return sc.id === campaign.id;
                    });

                    if (stored_campaigns.length > 0) {
                        stored_campaigns.forEach((stored_campaign) => {

                           if(_.size(campaign.requirements) > _.size(stored_campaign.requirements)){
                                 let clone = _.cloneDeep(campaign)
                                 _.each(clone.requirements,(req)=>{
                                    if(_.findIndex(stored_campaign.requirements,{referenceable:req.referenceable})===-1 && !campaign.split_promotion){
                                        req.campaign_unique_id = stored_campaign.unique_id
                                        req.originating_product.campaign_unique_id = stored_campaign.unique_id
                                        req.product.campaign_unique_id = stored_campaign.unique_id
                                        stored_campaign.requirements.push(req)
                                    }
                                 })
                           }
                           campaigns.push(stored_campaign);
                        });
                    } else {
                        campaigns.push(campaign);
                    }
                });
            }
            this.manipulatedProductCampaigns =
                campaigns.length > 0 //
                    ? campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index)
                    : this.productCampaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },

        checkAppliedCampaigns() {
            let campaigns = [];

            this.handleStoredMixCampaigns();
            this.normalOrderStore.restoreBaseCampaigns(this.productCampaigns);

            this.manipulatedProductCampaigns.forEach((campaign) => {
                let finalCampaign;

                let storedCampaign = this.normalOrderStore.getCampaignByUniqueIdAndProduct(campaign.unique_id, this.selectedProduct.id);
                if (storedCampaign) {
                    finalCampaign = storedCampaign;
                } else {
                    let storedCampaignFromAnotherRequirement = this.normalOrderStore.getCampaignByUniqueId(campaign.unique_id);

                    if (storedCampaignFromAnotherRequirement && storedCampaignFromAnotherRequirement.unique_id == campaign.unique_id) {

                        //if(campaign.split_promotion && campaign.is_purchased_product_offer && campaign.amount_of_requirements_needed==1){
                        if(campaign.split_promotion && campaign.amount_of_requirements_needed==1){

                            let hasCampaignStored = _.find(this.manipulatedProductCampaigns,{unique_id:campaign.unique_id})
                            let indexCampaign = _.findLastIndex(this.manipulatedProductCampaigns,{id:campaign.id})
                            let lastIndexCampaign = 0
                            let nextIndexCampaign = 0

                            if(indexCampaign == -1){
                                lastIndexCampaign = 0
                            }else{
                                let lastUniqueId = this.manipulatedProductCampaigns[indexCampaign].unique_id
                                let splitLastId = _.split(lastUniqueId,'_')
                                if(_.size(splitLastId)){
                                    lastIndexCampaign = parseInt(splitLastId[1])
                                }
                                nextIndexCampaign = lastIndexCampaign + 1
                            }

                            let groupCampaigns = _.filter(this.manipulatedProductCampaigns,{id:campaign.id})
                            let setNewCamp = false

                            if(hasCampaignStored){
                                if(hasCampaignStored.unique_id == campaign.id + '_' + lastIndexCampaign){
                                    setNewCamp  = !_.some(groupCampaigns, group =>
                                        _.some(group.requirements, r => r.referenceable == '' + this.selectedProduct.code)
                                    );
                                }
                            }

                            if(setNewCamp){

                                let newStoredCampaign = _.cloneDeep(storedCampaignFromAnotherRequirement)
                                newStoredCampaign.unique_id = campaign.id + "_" + nextIndexCampaign
                                if(campaign.is_purchased_product_offer){
                                    newStoredCampaign.offers = []
                                }
                                newStoredCampaign.in_shopping_cart = false
                                let getCampaignReq = _.find(this.productCampaigns,{id:campaign.id})
                                newStoredCampaign.requirements = getCampaignReq.requirements

                                _.each(newStoredCampaign.requirements, (req) => {
                                    req.campaign_unique_id = campaign.id + "_" + nextIndexCampaign
                                    req.product.campaign_unique_id = campaign.id + "_" + nextIndexCampaign
                                })
                                finalCampaign = newStoredCampaign
                            }

                        }else{
                            if(!campaign.split_promotion)
                              finalCampaign = storedCampaignFromAnotherRequirement;
                        }

                    } else {
                        finalCampaign = JSON.parse(JSON.stringify(this.originalProductCampaigns.find((c) => c.id === campaign.id)));
                    }
                }

                if (!finalCampaign || typeof finalCampaign !== 'object') return;

                if (!Array.isArray(finalCampaign.requirements)) {
                    finalCampaign.requirements = [];
                }

                // Add requirements with no quantity from baseCampaigns
                const baseCampaign = this.normalOrderStore.getBaseCampaignByUniqueId?.(campaign.unique_id);
                if (baseCampaign) {
                    if(!campaign.split_promotion){
                        const currentRequirements = Array.isArray(finalCampaign.requirements) ? finalCampaign.requirements : [];
                        const existingRequirementIds = currentRequirements.map((r) => r?.product?.id ?? null).filter((id) => id !== null);

                        const missingRequirements = baseCampaign.requirements.filter((req) => {
                            return !existingRequirementIds.includes(req.product.id);
                        });

                        finalCampaign.requirements.push(...missingRequirements);
                        //finalCampaign.requirements.sort((a, b) => a.product.id - b.product.id);
                    }
                }

                campaigns.push(finalCampaign);
            });

            this.manipulatedProductCampaigns = campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },

        onCloseDetailedCampaignDialog() {
            this.isDetailedCampaignDialogOpen = false;
        },

        acceptedShippingConditions() {
            this.isProductShippingConditionsDialogOpen = false;
            this.onAcceptedCallback();
        },

        openProductDetails(product) {
            this.selectedProduct = product;
            this.isProductDetailsDialogOpen = true;
        },

        getProductQuantity(product) {
            return this.normalOrderStore.isInCart(product) ? product.quantity : 0;
        },

        getProductBonusQuantity(product) {
            return this.normalOrderStore.isInCart(product) ? product.bonus : 0;
        },

        tryIncrement(product, amount) {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            if (product.quantity == 0 && amount === -1) return;

            const isInCart = this.normalOrderStore.isInCart(product);

            // If it's a special product, we only want to add it if the user accepts the dialog.
           if (!isInCart) {
                if (this.normalOrderStore.isSpecialProduct(product)) {
                    this.onAcceptedCallback = () => this.checkIfIsInPendingList(product, amount, 'tryIncrement');
                    this.selectedProduct = product;

                    this.isProductShippingConditionsDialogOpen = true;
                    return;
                }

                // @Note: It's not a special product, so check if the product is in the pending list.
                this.checkIfIsInPendingList(product, amount, 'tryIncrement');
                return;
            }

            this.increment(product, amount);
        },

        increment(product, amount) {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            if (this.branchStore.isBlocked) {
                this.showError(this.accountBlockedMessage);
                return;
            }

            if (!this.normalOrderStore.isInCart(product)) {
                if (amount < 0) return;

                product.quantity = 1;
                this.normalOrderStore.addProduct(product, this.currentSearchTerm);
                return;
            }

            // @Note: `amount` can be negative.
            if (product.bonus === 0 && product.quantity + amount <= 0) {
                this.normalOrderStore.removeProduct(product.id);
                return;
            }

            this.normalOrderStore.incrementProductQuantity(product.id, amount);
        },
        tryUpdateQuantity(product, amount) {

            let quantity = this.parseQuantity(amount, true);

            // If it's a special product, we only want to add it if the user accepts the dialog.
            if (!this.normalOrderStore.isInCart(product)) {
                if (quantity !== 0 && this.normalOrderStore.isSpecialProduct(product)) {
                    this.onAcceptedCallback = () => this.checkIfIsInPendingList(product, quantity, 'tryUpdateQuantity');
                    this.selectedProduct = product;

                    this.isProductShippingConditionsDialogOpen = true;
                    return;
                }

                // @Note: It's not a special product, so check if the product is in the pending list.
                if (quantity > 0) {
                    this.checkIfIsInPendingList(product, quantity, 'tryUpdateQuantity');
                }
                return;
            }

            this.onQuantityUpdated(product, quantity);
        },

        onQuantityUpdated(product, amount) {
            if (this.branchStore.isBlocked || this.branchStore.cannotPurchase) {
                this.showError(this.accountBlockedMessage);
                return;
            }

            const quantity = parseInt(amount);

            if (!this.normalOrderStore.isInCart(product) && quantity !== 0) {
                product.quantity = quantity;

                this.normalOrderStore.addProduct(product, this.currentSearchTerm);
                return;
            }

            if (this.normalOrderStore.isInCart(product)) {
                if (quantity === 0) {
                    this.normalOrderStore.removeProduct(product.id);
                    return;
                }

                this.normalOrderStore.setProductQuantity(product.id, quantity);
            }
        },

        tryUpdateCampaignQuantity(product, amount) {
            const campaign = this.normalOrderStore.getCampaignByIdAndProduct(product.campaign_id, product.id);
            const requirement = campaign.requirements.find((it) => it.product.index === product.index);

            this.onCampaignQuantityUpdated(requirement, amount);
        },

        onCampaignQuantityUpdated(requirement, amount) {
            requirement.product.quantity = this.parseQuantity(amount, true);
            this.changeCampaignQuantity(requirement);
        },

        changeCampaignQuantity(requirement, isIncrement = null) {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            this.selectedProduct = requirement.product;

            // At this point, the campaign is always active
            this.normalOrderStore.changeCampaignQuantityOnExisting(requirement.campaign_unique_id, requirement.product.index, isIncrement);
        },

        tryRemoveCampaign(product, isIncrement = null) {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            this.selectedProduct = product;
            const campaign = this.normalOrderStore.getCampaignForOriginatingProduct(product.originating_product_id);
            const fulfilledRequirements = [];

            for (const requirement of campaign.requirements) {
                if (!requirement.product.quantity) continue; // didn't buy in to this requirement.
                fulfilledRequirements.push(requirement);
            }

            if (campaign.amount_of_requirements_needed > 0 && fulfilledRequirements.length > campaign.amount_of_requirements_needed) {
                if (isIncrement === null) product.quantity = 0;
                this.normalOrderStore.changeCampaignQuantityOnExisting(product.campaign_unique_id, product.index, isIncrement, this.currentSearchTerm);
            } else {
                this.isRemoveCampaignDialogOpen = true;
            }
        },

        tryChangeProductBonus(product, amount, isAbsoluteAmountValue = false) {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            if (this.branchStore.isBlocked) {
                this.showError(this.accountBlockedMessage);
                return;
            }

            if(this.userStore.hasPermissionTo('Change bonus quantity (as propec)')){
                if(product.bonus == 0 && amount>0){
                    /*product['offer_type']=null
                    this.currentBonus = product
                    this.amount=amount
                    this.isAbsoluteAmountValue= isAbsoluteAmountValue
                    this.isOfferTypeDialogOpen=true
                    return;*/
                     product['offer_type']='BONUS FORN';
                }
                if(product.bonus == 1 && amount<=0){
                    product['offer_type']=null
                }
            }

            if (isAbsoluteAmountValue) product.bonus = this.parseQuantity(amount);
            if (product.bonus == 0 && amount === -1) return;



            if (!this.normalOrderStore.isInCart(product)) {
                if (this.normalOrderStore.isSpecialProduct(product)) {
                    this.onAcceptedCallback = () => this.checkIfBonusIsInPendingList(product, amount, isAbsoluteAmountValue);
                    this.selectedProduct = product;

                    this.isProductShippingConditionsDialogOpen = true;
                    return;
                }

                // @Note: It's not a special product, so check if the product is in the pending list.
                this.checkIfBonusIsInPendingList(product, amount, isAbsoluteAmountValue);
                return;
            }

            this.changeProductBonus(product, amount, isAbsoluteAmountValue);
        },
        //TODO:remove
        setBonusTypes(value){
            this.isOfferTypeDialogOpen=false
            this.currentBonus.offer_type=value
            this.$nextTick(_=>{
                this.currentOfferType=null
            })
            //console.log('setBonusTypes',this.currentOfferType);
            if (this.isAbsoluteAmountValue) this.currentBonus.bonus = this.parseQuantity(this.amount);
            if (this.currentBonus.bonus == 0 && this.amount === -1) return;

            if (!this.normalOrderStore.isInCart(this.currentBonus)) {
                if (this.normalOrderStore.isSpecialProduct(this.currentBonus)) {
                    this.onAcceptedCallback = () => this.checkIfBonusIsInPendingList(this.currentBonus, this.amount, this.isAbsoluteAmountValue);
                    this.selectedProduct = this.currentBonus;

                    this.isProductShippingConditionsDialogOpen = true;
                    return;
                }

                // @Note: It's not a special product, so check if the product is in the pending list.
                this.checkIfBonusIsInPendingList(this.currentBonus, this.amount, this.isAbsoluteAmountValue);
                return;
            }

            this.changeProductBonus(this.currentBonus, this.amount, this.isAbsoluteAmountValue);
        },
        changeProductBonus(product, amount, isAbsoluteAmountValue) {
            if (!this.normalOrderStore.isInCart(product)) {
                if (amount < 0) return;

                product.bonus = amount;
                this.normalOrderStore.addProduct(product, this.currentSearchTerm);
                return;
            }

            // @Note: `amount` can be negative.
            if ((!isAbsoluteAmountValue && product.quantity === 0 && product.bonus + amount <= 0) || (isAbsoluteAmountValue && product.quantity === 0 && product.bonus <= 0)) {
                this.normalOrderStore.removeProduct(product.id);
                return;
            }

            if (isAbsoluteAmountValue) {
                this.normalOrderStore.setProductBonus(product.id, amount);
            } else {
                this.normalOrderStore.incrementProductBonus(product.id, amount);
            }
        },
        onDataChanges(value) {
            // If the product is in the cart, we want to change the quantities accordingly.
            const products = Array.isArray(this.normalOrderStore.getProducts) ? this.normalOrderStore.getProducts : [];
            const cartProductIds = new Set(products.map((p) => p.id));

            for (const [index, product] of value?.data?.entries() ?? []) {
                if (cartProductIds.has(product.id)) {
                    const item = { ...this.normalOrderStore.getProduct(product.id) };
                    item.has_campaign = product.has_campaign;
                    this.$set(value.data, index, item);
                }
            }

            // Update local paginator data so that we can later display the campaigns.
            this.$set(this, 'products', value?.data ?? []);

            const wrapper = this.$refs['datatable']?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },
        /*onDataChangesOLD(value) {
            // If the product is in the cart, we want to change the quantities accordingly.
            for (const [index, product] of value?.data?.entries() ?? []) {
                if (this.normalOrderStore.isInCart(product)) {
                    const item = this.normalOrderStore.getProduct(product.id);
                    this.$set(value.data, index, item);
                }
            }

            // Update local paginator data so that we can later display the campaigns.
            this.$set(this, 'products', value?.data ?? []);

            const wrapper = this.$refs['datatable']?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },*/

        async checkIfIsInPendingList(product, amount, type) {
            const branchId = this.branchStore.branch?.id;

            const fetchData = () => {
                return axios.get(`/api/orders/is-pending-product/${branchId}/${product.code}`, {
                    timeout: 2000,
                });
            };
            await fetchData()
                .then((response) => {
                    if (response.data) {
                        this.onAcceptedCallback = () => (type === 'tryUpdateQuantity' ? this.onQuantityUpdated(product, amount) : this.increment(product, amount));
                        this.selectedProduct = product;

                        this.isProductInPendingProductsDialogOpen = true;
                        return;
                    } else {
                        type === 'tryUpdateQuantity' ? this.onQuantityUpdated(product, amount) : this.increment(product, amount);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    type === 'tryUpdateQuantity' ? this.onQuantityUpdated(product, amount) : this.increment(product, amount);
                });
        },

        async checkIfBonusIsInPendingList(product, amount, isAbsoluteAmountValue) {
            const branchId = this.branchStore.branch?.id;

            const fetchData = () => {
                return axios.get(`/api/orders/is-pending-product/${branchId}/${product.code}`, {
                    timeout: 2000,
                });
            };
            await fetchData()
                .then((response) => {
                    if (response.data) {
                        this.onAcceptedCallback = () => this.changeProductBonus(product, amount, isAbsoluteAmountValue);
                        this.selectedProduct = product;

                        this.isProductInPendingProductsDialogOpen = true;
                        return;
                    } else {
                        this.changeProductBonus(product, amount, isAbsoluteAmountValue);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.changeProductBonus(product, amount, isAbsoluteAmountValue);
                });
        },

        acceptedPendingProductList() {
            this.isProductInPendingProductsDialogOpen = false;
            this.onAcceptedCallback();
        },

        acceptedRemoveCampaign() {
            if (this.isDetailedCampaignDialogOpen) this.isDetailedCampaignDialogOpen = false;
            this.remove(this.selectedProduct);
        },

        remove(item) {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            if ('campaign_id' in item) {
                this.normalOrderStore.removeCampaign(item.campaign_unique_id, item.id);
                this.isRemoveCampaignDialogOpen = false;
            } else {
                this.normalOrderStore.removeProduct(item.id);
            }
        },

        maxQuantityCampaign(max_quantity) {
            return max_quantity > 0 ? max_quantity : 9999999;
        },

        offerBonusQuantity(product) {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            if (product.isOffer) return product.quantity;

            return product.campaign_id != null //
                ? this.normalOrderStore.aggregateCampaignRequirementBonus(product)
                : product.bonus;
        },

        createNewOriginalCampaign(campaign) {
            let campaigns = [];

            const newOriginalCampaign = () => {
                const originalCampaign = this.originalProductCampaigns.find((c) => {
                    return c.id == campaign.id;
                });

                if (!originalCampaign) return false;

                const maxIndexCampaign = this.manipulatedProductCampaigns.filter((c) => c.id === campaign.id).reduce((prev, current) => (prev && prev.index > current.index ? prev : current));

                let oc = originalCampaign;
                oc.index = maxIndexCampaign.index + 1;
                oc.unique_id = oc.id + '_' + oc.index;

                // Manipulate requirements unique_id
                oc.requirements.forEach((requirement, index) => {
                    requirement.campaign_unique_id = oc.unique_id;
                    requirement.product.campaign_unique_id = oc.unique_id;
                    requirement.product.uniqueId = requirement.product.id + '_' + oc.unique_id + '_header_' + index;
                });

                // Manipulate requirements unique_id
                oc.offers.forEach((offer, index) => {
                    offer.campaign_unique_id = oc.unique_id;
                    offer.product.campaign_unique_id = oc.unique_id;
                    offer.product.uniqueId = offer.product.id + '_' + oc.unique_id + '_offer_' + index;
                });

                return oc;
            };

            this.manipulatedProductCampaigns.forEach((manipulatedCampaign) => {
                campaigns.push(manipulatedCampaign);

                if (manipulatedCampaign.unique_id === campaign.unique_id) {
                    campaigns.push(JSON.parse(JSON.stringify(newOriginalCampaign())));
                }
            });

            this.manipulatedProductCampaigns = campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },

        productHasActiveCampaign(productId) {
            return this.normalOrderStore.hasActiveCampaign(productId);
        },
    },
};
</script>

<style>
.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}

#form-base > div > .v-input > .v-input__control > .v-input__slot .v-input__icon--prepend-inner button.v-icon {
    color: #154579;
    font-size: 18px !important;
}
.datatable-image{
    height: 35px;
    width: 35px;
    display: inline-block;
    margin-right: 10px;
    min-width: 35px;
    min-height: 35px;
}
.datatable-image .image-product-list{
    background-position: 50% 50%;
    background-size: contain;
    height: 100%;
    transform: scale(1.4);
    --webkit-transform: scale(1.4);
    --moz-transform: scale(1.4);
    --ms-transform: scale(1.4);
    --o-transform: scale(1.4);
    background-repeat: no-repeat;
}

.datatable-new+.datatable-video{
     margin-top: 24px;
}
</style>
